import * as React from 'react';
import { useState, useRef } from "react";
import axios from 'axios';
import Sidebar from '../components/sidebar'
import Footer from '../components/footer'
import Head from '../components/head'
import JoditEditor from 'jodit-react';
import { convertDocxToHtml } from './docxToHtml';

const editorConfig = {
  height: 450,
  buttons: [
    'bold', 'italic', 'underline', 'strikethrough', '|',
    'superscript', 'subscript', '|',
    'font', 'fontsize', 'brush', 'paragraph', '|',
    'align', '|',
    'ul', 'ol', '|',
    'table', '|',
    'link', 'image', 'video', '|',
    'blockquote', '|',
    'eraser', '|',
    'undo', 'redo'
  ],
  format: {
    h1: 'Heading 1',
    h2: 'Heading 2',
    h3: 'Heading 3',
    h4: 'Heading 4',
    h5: 'Heading 5',
    h6: 'Heading 6',
    p: 'Normal',
    blockquote: 'Quote',
  },
  removeButtons: [],
  showCharsCounter: false,
  showWordsCounter: false,
  showXPathInStatusbar: false,
};

export default function Main() {
  const editorRef = useRef(null);

  const [url, setUrl] = useState("")
  const [title, setTitle] = useState('')
  const [des, setDes] = useState('')
  const [key, setKey] = useState('')
  const [h1, setH1] = useState('')
  const [h1des, setH1des] = useState('')
  const [h2_a, setH2_a] = useState('')
  const [h2_b, setH2_b] = useState('')
  const [h2_c, setH2_c] = useState('')
  const [ex1, setEx1] = useState('')
  const [ex2, setEx2] = useState('')
  const [code, setCode] = useState('')

  const handleDocxUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    if (!file.name.toLowerCase().endsWith('.docx')) {
      alert("Sirf Word (.docx) file upload karain. Purani .doc file support nahi hai — us ko Word mein 'Save As .docx' karein.");
      event.target.value = '';
      return;
    }
    try {
      const arrayBuffer = await file.arrayBuffer();
      const result = await convertDocxToHtml(arrayBuffer);
      setCode(result.html);
      if (result.messages && result.messages.length) {
        console.log('Mammoth conversion messages:', result.messages);
      }
    } catch (err) {
      console.log('docx convert error =>>', err);
      alert("File convert nahi ho saki. Dobara koshish karein.");
    } finally {
      event.target.value = '';
    }
  };

  const getDb = async () => {
    const data = new FormData();
    data.append('url', url);
    data.append('t', title);
    data.append('des', des);
    data.append('h1', h1);
    data.append('h1_des', h1des);
    data.append('h2_a', h2_a);
    data.append('h2_b', h2_b);
    data.append('h2_c', h2_c);
    data.append('ex1', ex1);
    data.append('ex2', ex2);
    data.append('code', code);
    data.append('keyword', key);
    axios({
      method: 'post',
      url: '/api/seo/add.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        if (s.data[0].msg === "already") {
          alert("already SEO here")
        } else if (s.data[0].msg === "fail") {
          alert("Fail here")
        } else {
          alert("Saved here")
        }
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  return (
    <>
      <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
          <Head />
          <div>
            <div className="page-content">
              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-header bg-gradient-primary text-white py-4">
                      <div className="d-flex align-items-center">
                        <div className="avatar avatar-sm me-3 bg-white text-dark rounded-circle d-flex align-items-center justify-content-center">
                          <i className="link-icon" data-feather="search" style={{ width: '18px', height: '18px' }}></i>
                        </div>
                        <div>
                          <h4 className="mb-1">Create New SEO</h4>
                          <span className="opacity-75">Optimize your page for search engines</span>
                        </div>
                        <span className="badge bg-light text-dark ms-auto py-2 px-3">
                          <i className="link-icon me-1" data-feather="trending-up" style={{ width: '14px', height: '14px' }}></i>
                          Recommended
                        </span>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-6 mb-3">
                          <label htmlFor="fullname" className="form-label">URL</label>
                          <input type="text" className="form-control" id="fullname" autoComplete="off"
                            value={url} onChange={(v) => setUrl(v.target.value)} />
                        </div>
                        <div className="col-lg-6 mb-3">
                          <label htmlFor="email" className="form-label">Meta Title (50–60 characters.)</label>
                          <input type="text" className="form-control" id="email" autoComplete="off"
                            value={title} onChange={(v) => setTitle(v.target.value)} />
                        </div>
                        <div className="col-lg-12 mb-3">
                          <label className="form-label">Meta Description ( between 50 — 160 characters )</label>
                          <textarea className="form-control" onChange={(v) => setDes(v.target.value)}>{des}</textarea>
                        </div>
                        <div className="col-lg-12 mb-3">
                          <label className="form-label">All keywords</label>
                          <input type="text" className="form-control" autoComplete="off"
                            value={key} onChange={(v) => setKey(v.target.value)} />
                        </div>
                        <div className="col-lg-12 mb-3">
                          <label className="form-label">H1</label>
                          <input type="text" className="form-control" autoComplete="off"
                            value={h1} onChange={(v) => setH1(v.target.value)} />
                        </div>
                        <div className="col-lg-12 mb-3">
                          <label className="form-label">H1 des</label>
                          <input type="text" className="form-control" autoComplete="off"
                            value={h1des} onChange={(v) => setH1des(v.target.value)} />
                        </div>
                        <div className="col-lg-12 mb-3">
                          <label className="form-label">H2 A</label>
                          <input type="text" className="form-control" autoComplete="off"
                            value={h2_a} onChange={(v) => setH2_a(v.target.value)} />
                        </div>
                        <div className="col-lg-6 mb-3">
                          <label className="form-label">H2 B</label>
                          <input type="text" className="form-control" autoComplete="off"
                            value={h2_b} onChange={(v) => setH2_b(v.target.value)} />
                        </div>
                        <div className="col-lg-6 mb-3">
                          <label className="form-label">H2 C</label>
                          <input type="text" className="form-control" autoComplete="off"
                            value={h2_c} onChange={(v) => setH2_c(v.target.value)} />
                        </div>
                        <div className="col-lg-6 mb-3">
                          <label className="form-label">EX 1</label>
                          <input type="text" className="form-control" autoComplete="off"
                            value={ex1} onChange={(v) => setEx1(v.target.value)} />
                        </div>
                        <div className="col-lg-6 mb-3">
                          <label className="form-label">EX 2</label>
                          <input type="text" className="form-control" autoComplete="off"
                            value={ex2} onChange={(v) => setEx2(v.target.value)} />
                        </div>
                        <div className="col-lg-12 mb-3">
                          <div dangerouslySetInnerHTML={{ __html: code }} />
                        </div>
                        <div className="col-lg-12 mb-5">
                          <label className="form-label">Content</label>
                          <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
                            <input
                              type="file"
                              accept=".docx"
                              className="form-control"
                              style={{ maxWidth: '340px' }}
                              onChange={handleDocxUpload}
                            />
                            <small className="text-muted">
                              Word (.docx) file upload karain — content khud-ba-khud editor mein aa jayega. Zarurat ho to edit karke save karain.
                            </small>
                          </div>
                          <JoditEditor
                            ref={editorRef}
                            value={code}
                            config={editorConfig}
                            onBlur={(newContent) => setCode(newContent)}
                          />
                        </div>
                        <div className="col-lg-12 d-flex justify-content-end mt-4">
                          <button className="btn btn-primary px-4" onClick={() => { getDb(); }}>
                            <i className="link-icon" data-feather="plus" /> SEO Data
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}
